export const SET_SRGLINES_FIRST_LOAD = "SET_SRGLINES_FIRST_LOAD";
export const SET_SRGLINES_DATA = "SET_SRGLINES_DATA";
export const SET_LOADING_SRGLINES_DATA = "SET_LOADING_SRGLINES_DATA";
export const SET_EDIT_SRGLINES_DATA = "SET_EDIT_SRGLINES_DATA";
export const SET_SRGLINES_FILTER = "SET_SRGLINES_FILTER";
export const SET_SRGLINES_SORTING = "SET_SRGLINES_SORTING";
export const SET_SRGLINES_ROWS_PER_PAGE = "SET_SRGLINES_ROWS_PER_PAGE";
export const SET_SUCCESS_PROMPT_SRGLINES_PAGE =
  "SET_SUCCESS_PROMPT_SRGLINES_PAGE";
export const SET_SUCCESS_MESSAGE_SRGLINES_PAGE =
  "SET_SUCCESS_MESSAGE_SRGLINES_PAGE";
export const SET_ERROR_PROMPT_SRGLINES_PAGE = "SET_ERROR_PROMPT_SRGLINES_PAGE";
export const SET_ERROR_MESSAGE_SRGLINES_PAGE =
  "SET_ERROR_MESSAGE_SRGLINES_PAGE";
export const SET_INFO_PROMPT_SRGLINES_PAGE = "SET_INFO_PROMPT_SRGLINES_PAGE";
export const SET_INFO_MESSAGE_SRGLINES_PAGE = "SET_INFO_MESSAGE_SRGLINES_PAGE";
